<script>
    import UploadComponent from "./UploadComponent.svelte";
    import {links} from "svelte-routing";
    import Time from "svelte-time";
    import Service from "../utils/Service";
    import {afterUpdate} from "svelte";

    export let model_root;
    export let application_root;
    export let content_id;
    export let file_type;

    let  upload_component;

    const service = new Service(model_root);

    $ : files = service.loadFiles(content_id, file_type);

    // rename related variables
    let renameFileId = null;
    let renameFileOldName = undefined;

    function reloadFiles() {
        files = service.loadFiles(content_id, file_type);
    }

    function removeFile(fid) {
        return service.removeFile(fid)
            .then((response) => {
                reloadFiles();
            });
    }

    function toggleThumbnail(fid) {
        return fetch(model_root + 'admin/files/set_thumbnail.php?f=' + fid + '&c=' + content_id, {
            method: "GET"
        })
            .then(async (res) => {
                reloadFiles();
                //const msg = await res.text()
                //alert(msg)
            });
    }

    function toggleSpotlight(fid) {
        return fetch(model_root + 'admin/files/toggle_spotlight.php?f=' + fid + '&c=' + content_id, {
            method: "GET"
        })
            .then(() => {
                reloadFiles();
            });
    }

    function toggleRename(fid, fname) {
        if (fid === undefined || renameFileId == fid) {
            const editableField = document.querySelector(".editable-file-name[contenteditable='true']");
            editableField.textContent = renameFileOldName;
            renameFileId = null;
            renameFileOldName = undefined;
            removeTextSelection();
            return;
        }
        renameFileId = fid;
        renameFileOldName = fname;
    }

    function enableEditableField() {
        const editableField = document.querySelector(".editable-file-name[contenteditable='true']");
        window.getSelection().selectAllChildren(editableField);
    }

    function removeTextSelection() {
        if (window.getSelection) {
            if (window.getSelection().empty) {  // Chrome
                window.getSelection().empty();
            } else if (window.getSelection().removeAllRanges) {  // Firefox
                window.getSelection().removeAllRanges();
            }
        } else if (document.selection) {  // IE?
            document.selection.empty();
        }
    }

    afterUpdate(() => {
        if (renameFileId !== null) {
            enableEditableField();
        }

    });

    function saveNewFileName() {
        const editableField = document.querySelector(".editable-file-name[contenteditable='true']");
        const newName = editableField.textContent;
        //console.log(newName);

        const data = new FormData();
        data.append("id", renameFileId);
        data.append("name", newName);

        fetch(model_root + 'admin/files/rename_file.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                if(msg === "success") {
                    // success msg
                } else {
                    // error msg
                }
                toggleRename();
                reloadFiles();
            });
    }

</script>

<div use:links class="mt-5 mb-3">
    {#await files}
        <p class="alert alert-light">
            <i class="fas fa-circle-notch fa-spin"></i> Lade
            {#if file_type === "image"}
                Bilder
            {:else}
                Dateien
            {/if}
            ...
        </p>
    {:then items}

        <ul class="list-group">
            {#each items as file}

                <li class="list-group-item">

                    {#if file_type === "image"}
                        <div class="thumbnail_container border rounded overflow-hidden me-2">
                            <img src="{application_root}files/{file.fpath}">
                        </div>
                    {/if}
                    <div class="d-inline-block h-100 align-top" style="max-width: 53%">
                        <p class="editable-file-name fw-bold d-inline" contenteditable={renameFileId == file.fid}>{@html file.fname}</p>
                        <br>
                        <small class="text-muted">Hochgeladen am <Time timestamp="{file.ftimestamp}" format="DD.MM.YYYY" /></small>
                        {#if file_type === "image"}

                            <div class="d-block mt-1" role="group">
                                <button type="button"
                                        class={file.fthumbnail == 0 ? "btn btn-light" : "btn btn-dark"}
                                        on:click={ () => { toggleThumbnail(file.fid) } }>
                                    <i class="fas fa-image"></i> Vorschaubild
                                </button>
                                <button type="button"
                                        class={file.fspotlight == 0 ? "btn btn-light" : "btn btn-dark"}
                                        on:click={ () => { toggleSpotlight(file.fid) } }
                                        disabled={file.fthumbnail == 1}>
                                    <i class="fas fa-star"></i> Spotlight
                                </button>
                            </div>

                        {/if}
                    </div>

                    <button on:click={() => {removeFile(file.fid)}}  class="btn btn-danger float-end mx-1 mt-1" title="Datei löschen">
                        <i class="fas fa-trash-alt"></i>
                    </button>
                    <button on:click={(event) => {toggleRename(file.fid, file.fname)}}  class="btn btn-outline-dark float-end mx-1 mt-1" title="Datei umbenennen">
                        {#if renameFileId == file.fid}
                            <i class="fas fa-times"></i>
                        {:else}
                            <i class="fas fa-pen"></i>
                        {/if}
                    </button>
                    {#if renameFileId == file.fid}
                        <button on:click={() => {saveNewFileName()}}  class="btn btn-primary float-end mx-1 mt-1" title="Neuen Namen speichern">
                            <i class="fas fa-check"></i>
                        </button>
                    {/if}

                </li>

            {/each}

            <li class="list-group-item pt-3 pb-3 bg-light text-dark" role="button" on:click={upload_component.showUploadMenu}>
                <i class="fas fa-plus"></i>
                {#if file_type === "image"}
                    Bilder
                {:else}
                    Dateien
                {/if}
                hochladen
            </li>
        </ul>

    {:catch error}
        <p style="color: red">{error.message}</p>
    {/await}
</div>

<UploadComponent {content_id} {file_type} {model_root} bind:this={upload_component} on:upload_finished={reloadFiles}/>

<style>

    .thumbnail_container {
        height: 60px;
        width: 80px;
        display: inline-block;
    }

    .thumbnail_container img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
</style>

